<template>
	<div class="agree-bg">
		<div class="main-xieyi-content">
			<div class="main-xieyi-title">版权声明</div>
			<div class="main-xieyi-pcontent">
				<p class="p-title">智慧生活10000号根据用户指令提供作品上传、下载以及传播等，向来十分重视网络版权及其他知识产权以及用户权益的保护。为共同净化网络空间减少侵权行为发生，智慧生活10000号采取如下措施：</p>
				<p class="p-content">1. 智慧生活10000号向用户传达版权保护理念，提示用户不得上传和传播侵权作品，提示用户严格遵守法律法规及尊重他人合法权益。</p>
				<p class="p-content">2. 在合理的注意义务范围内对作品进行审核。</p>
				<p class="p-content">3. 对于有权属证据证明存在明显侵权或违反公共利益等情形的作品时，有权不事先通知用户并删除该等侵权作品。</p>
				<p class="p-content">4. 智慧生活10000号尊重作品版权，鼓励用户对网站作品进行全面监督，如果发现侵权情况，支持将侵权情况告知，智慧生活10000号会在第一时间进行核实，并及时清理侵权作品，并对上传者进行处罚。</p>
				<p class="p-content">5.
					用户下载智慧生活10000号作品，应根据作品详情页标识用途及作品的授权许可范围进行使用，商用授权作品在作品详情页会有明确商用标识。用户应自觉遵守著作权法及相关法律法规的规定，不得侵犯智慧生活10000号及权利人的合法权利。</p>
				<p class="p-content">6．如果您认为智慧生活10000号用户通过智慧生活10000号提供的服务或传播的内容侵犯了您的合法权益，请您通过以下方式向智慧生活10000号发起版权投诉或侵权通知：</p>
				<p class="p-content" style="color:#4A4A4A">邮箱：{{getQQService}}@qq.com</p>
			</div>
			<div class="main-xieyi-pcontent" style="margin-bottom:45px;">
				<p class="p-title">投诉／申诉须知</p>
				<p class="p-content">投诉／申诉人应为作品的利害关系人</p>
				<p class="p-content">投诉／申诉方应当提供以下文件：</p>
				<p class="p-content">1．权利人信息：姓名（名称）、联系方式、地址、身份证扫描件（自然人）、企业法人营业执照（单位）、法定代表人身份证明（单位）。</p>
				<p class="p-content">2．侵权作品信息：所涉及作品的准确名称和网络链接，以便智慧生活10000号能够发现并初步审核涉嫌侵权作品。</p>
				<p class="p-content">3．权属证据：认为构成侵权的初步证明材料，包括但不限于对作品享有版权或依法享有信息网络传播权的权属证明。</p>
				<p class="p-content">4．其他侵权证据。</p>
				<p class="p-content">5．通知书需由权利人或其合法授权人亲笔签名，若为单位则需加盖单位公章。</p>
				<p class="p-content">6．投诉／申诉人应对通知书的真实性负责。若通知书的内容不真实，权利人将承担由此产生的全部法律责任。</p>
				<p class="p-content">7．由于投诉／申诉涉及内容不同，智慧生活10000号所需处理周期也不同，请您耐心等待。</p>
				<p class="p-content">
					若通知符合上述所有要求，可推定相关权利主张成立，智慧生活10000号将在合理时间内删除涉嫌侵权的作品。否则，智慧生活10000号有权暂不予处理。若后续出现新的事实推翻了投诉／申诉人的权利主张，智慧生活10000号有权恢复相关作品链接。</p>
				<p class="p-content">
					在智慧生活10000号上传作品的用户视为同意智慧生活10000号就作品涉嫌侵权情形下所采用的相应措施，智慧生活10000号不因此承担任何法律责任。智慧生活10000号在收到版权投诉或侵权通知后会及时转告上传该等作品的用户。对于多次上传侵权作品的用户，智慧生活10000号有权取消其用户资格。
				</p>
			</div>
		</div>
	</div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import {getConfigQQ} from "@/api/config";

export default {
  computed: {
    ...mapGetters(["getQQService"]),
  },
/*  created() {
    this.getQQKefu()
  },
  methods:{
    ...mapActions(["setQQService"]),
    getQQKefu() {
      getConfigQQ("qq").then(res => {
        this.setQQService(res.data.content);
      })
    }
  },*/
	};
</script>
<style scoped>
	.agree-bg {
		width: 100%;
		background: #F4F4F4;
		overflow: hidden;
		display: flex;
		justify-content: center;
	}

	.main-xieyi-content {
		width: 995px;
		background: #fff;
		float: left;
		margin-left: 20px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.main-xieyi-title {
		margin-left: 25px;
		margin-top: 45px;
		font-size: 16px;
		color: #4A4A4A;
		margin-right: 25px;
		font-weight: bold;
	}

	.main-xieyi-pcontent p {
		margin-left: 25px;
		margin-right: 25px;
	}

	.p-content {
		font-size: 14px;
		color: #888888;
		margin-bottom: 20px;
		line-height: 22px;
	}

	.p-title {
		margin-top: 30px;
		margin-bottom: 25px;
		font-size: 14px;
		color: #4A4A4A;
		font-weight: bold;
	}
</style>
